import * as Actions from '../theme';
export var changeTheme = function () {
    return { type: Actions.CHANGE_THEME };
};



// WEBPACK FOOTER //
// ./src/actions/creators/theme.js